import usePulseId from "@pulse/hooks/usePulseId";
import { useCreateSurvey } from "@pulse/hooks/surveyHooks";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSelectedCustomerIdParam } from "@/features/hub/selectedCustomerContext";
import { Button, PageHeaderRight } from "frontend-components";

export default function CreateSurveyButton() {
    const { t } = useTranslation();
    const pulseId = usePulseId();
    const customerId = useSelectedCustomerIdParam();
    const navigate = useNavigate({ from: "/$customerId/pulse/$pulseId" });
    const mutation = useCreateSurvey({ pulseInstance: Number(pulseId)! });

    return (
        <PageHeaderRight>
            <Button
                variant="fill"
                className="gap-2"
                disabled={mutation.isPending}
                onClick={async () => {
                    const { id, pulseInstanceId } = await mutation.mutateAsync({
                        title: t("dashboard.newSurvey"),
                        description: null,
                    });
                    navigate({
                        to: "/$customerId/pulse/$pulseId/surveys/$surveyId/edit",
                        params: {
                            customerId,
                            surveyId: String(id),
                            pulseId: String(pulseInstanceId),
                        },
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlus} />
                {t("dashboard.createSurvey")}
            </Button>
        </PageHeaderRight>
    );
}
